import { Button, ButtonGroup, Heading } from '@flixbus/honeycomb-react';
import styles from './sign-in-card.module.scss';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../Auth/authConfig';

const SignInCard = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest);
  };
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <flix-illustration name='voucher' />
        </div>
        <Heading flushSpace extraClasses={styles.title} size={1}>
          Voucher Portal
        </Heading>
        <ButtonGroup orientation='vertical' extraClasses={styles.buttonGroup} gap='2'>
          <Button
            appearance='primary'
            size='lg'
            extraClasses={styles.loginCTA}
            onClick={handleLogin}
          >
            Sign in with SSO
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default SignInCard;
